import React from 'react';

const ContextMenuContext = React.createContext({
  selectedItemId: null,
  onSelectMenuItem: null,
  onClose: null,
});

export default ContextMenuContext;
